import React, { useEffect, useRef, useState } from 'react';
// styles
import styled, { css } from 'styled-components';
import { TimeIcon } from 'refactored/ui/icons';
import { useClickOutside } from 'refactored/ui/utils';
import { getHoursAndMinutesFromDate } from './economyUtils';
import { useTranslation } from 'react-i18next';

const Input = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;

  /* secondary / white */

  background: #ffffff;
  /* grey / 300 */

  border-width: 1px 1px 1px 4px;
  border-style: solid;
  border-color: #ccd6e0;
  border-radius: 4px;
  height: 48px;
  box-sizing: content-box;
`;

const IconContainer = styled.div`
  /* Auto layout */

  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 8px;
  gap: 10px;

  width: 48px;
  height: 48px;

  /* grey / 100 */

  background: #f2f5f8;
  /* grey / 300 */
`;

const InputValueContainer = styled.div`
  /* box-sizing: border-box; */

  /* Auto layout */

  display: flex;
  flex-direction: row;
  align-items: center;
  /* padding: 6px 12px 2px; */
  /* gap: 12px; */

  /* width: 228px; */
  width: 100%;
  height: 100%;
  /* height: 48px; */

  /* secondary / white */

  background: #ffffff;
  /* border: 1px solid red; */
`;

const InputValue = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0px;
  padding: 6px 12px 2px;

  /* width: 204px; */
  height: 100%;
  /* border: 1px solid black; */
  width: 100%;
  ${(props) =>
    props.isLast &&
    css`
      border-left: 1px solid var(--grey300);
    `}
  position:relative;
`;

const InputValueLabel = styled.div`
  height: 16px;

  /* 12px/medium */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */

  display: flex;
  align-items: center;

  /* grey / 500 */

  color: #94a6b8;
`;

const InputValueText = styled.div`
  height: 24px;

  /* 16px/regular

Shipper App Default
*/
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* grey / 900 */

  color: #263340;
`;

const Dropdown = styled.div`
  border: 1px solid green;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;

  position: absolute;
  top: 110%;
  left: 0;
  right: 0;
  max-height: 240px;
  overflow: auto;

  /* grey / 100 */

  background: #f2f5f8;
  /* grey / 300 */

  border: 1px solid #ccd6e0;
  border-radius: 4px;
`;

const DropdownItem = styled.div`
  box-sizing: border-box;

  /* Auto layout */

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 8px 12px;
  gap: 10px;

  width: 100%;
  height: 40px;

  /* grey / 200 */

  background: white;
  cursor: pointer;

  border-bottom: 1px solid #e2e8ee;
  &:hover {
    background: #e0eaff;
  }
  ${(props) =>
    !!props.isSelected &&
    css`
      background: var(--grey300);
      &:hover {
        background: var(--grey300);
      }
    `};
`;

const DropdownItemSeparator = styled(DropdownItem)`
  background: var(--grey200);
  height: auto;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */

  text-transform: uppercase;

  /* grey / 700 */

  color: #54708c;
  cursor: default;
`;

const SoHourPicker = ({
  className,
  timeFrom,
  timeTo,
  availableTimesFrom,
  availableTimesTo,
  selectFromFunction,
  selectToFunction,
}) => {
  const { t } = useTranslation('Catalog');

  const clickRefFrom = React.useRef();
  useClickOutside(clickRefFrom, () => {
    setIsOpenedFrom(false);
  });
  const [isOpenedFrom, setIsOpenedFrom] = useState(false);

  const clickRefTo = React.useRef();
  useClickOutside(clickRefTo, () => {
    setIsOpenedTo(false);
  });
  const [isOpenedTo, setIsOpenedTo] = useState(false);

  const internalSelectFromFunction = (item, e) => {
    e.stopPropagation();
    selectFromFunction(item);
    setIsOpenedFrom(false);
  };

  const internalSelectToFunction = (item, e) => {
    e.stopPropagation();
    selectToFunction(item);
    setIsOpenedTo(false);
  };

  const displayTimeFrom = getHoursAndMinutesFromDate(timeFrom);
  const displayTimeTo = getHoursAndMinutesFromDate(timeTo);

  const refFrom = useRef(null);
  const refTo = useRef(null);

  useEffect(() => {
    if (isOpenedFrom) {
      try {
        refFrom.current.scrollIntoView();
      } catch (e) {}
    }
  }, [isOpenedFrom]);

  useEffect(() => {
    if (isOpenedTo) {
      try {
        refTo.current.scrollIntoView();
      } catch (e) {}
    }
  }, [isOpenedTo]);

  return (
    <div className={className}>
      <Input>
        <IconContainer>
          <TimeIcon />
        </IconContainer>

        <InputValueContainer>
          <InputValue
            onClick={() => setIsOpenedFrom(!isOpenedFrom)}
            ref={clickRefFrom}
          >
            <InputValueLabel>{t('price.from')}</InputValueLabel>
            <InputValueText>{displayTimeFrom}</InputValueText>

            {isOpenedFrom && (
              <Dropdown>
                {availableTimesFrom.map((item) => {
                  const isItemSelected = item.time === timeFrom;
                  if (!item.isDaySeparator) {
                    return (
                      <DropdownItem
                        key={item.time}
                        isSelected={isItemSelected}
                        ref={isItemSelected ? refFrom : null}
                        onClick={(e) => internalSelectFromFunction(item, e)}
                      >
                        <InputValueText>{item.label}</InputValueText>
                      </DropdownItem>
                    );
                  } else {
                    return (
                      <DropdownItemSeparator>
                        {t('price.next_day')}
                      </DropdownItemSeparator>
                    );
                  }
                })}
              </Dropdown>
            )}
          </InputValue>
          <InputValue
            isLast
            onClick={() => setIsOpenedTo(!isOpenedTo)}
            ref={clickRefTo}
          >
            <InputValueLabel>{t('price.to')}</InputValueLabel>
            <InputValueText>{displayTimeTo}</InputValueText>
            {isOpenedTo && (
              <Dropdown>
                {availableTimesTo.map((item, index) => {
                  const isItemSelected = item.time === timeTo;
                  if (!item.isDaySeparator) {
                    return (
                      <DropdownItem
                        key={item.time}
                        isSelected={isItemSelected}
                        ref={isItemSelected ? refTo : null}
                        onClick={(e) => internalSelectToFunction(item, e)}
                      >
                        <InputValueText>{item.label}</InputValueText>
                      </DropdownItem>
                    );
                  } else {
                    return (
                      <DropdownItemSeparator>
                        {t('price.next_day')}
                      </DropdownItemSeparator>
                    );
                  }
                })}
              </Dropdown>
            )}
          </InputValue>
        </InputValueContainer>
      </Input>
    </div>
  );
};

export default styled(SoHourPicker)`
  /* border: 1px solid black; */
  width: 100%;
  position: relative;
`;

// a las 21:18
